import React from "react";

export default function Banner({ name, image, link }) {
  return (
    <section className="banner__all">
      <section className="banner">
        <a href={link} target="_blank" rel="noopener noreferrer">
          <img src={image} alt={name} className="banner__image" />
        </a>
      </section>
    </section>
  );
}
